import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconCaretDownBold = generateIcon({
  name: 'CaretDownBold',
  path: (
    <path d="M27.0613 13.0613L17.0613 23.0613C16.9219 23.2011 16.7563 23.312 16.574 23.3878C16.3917 23.4635 16.1962 23.5024 15.9988 23.5024C15.8013 23.5024 15.6059 23.4635 15.4235 23.3878C15.2412 23.312 15.0756 23.2011 14.9363 23.0613L4.93626 13.0613C4.65446 12.7795 4.49615 12.3973 4.49615 11.9988C4.49615 11.6002 4.65446 11.218 4.93626 10.9363C5.21805 10.6545 5.60024 10.4962 5.99876 10.4962C6.39727 10.4962 6.77946 10.6545 7.06126 10.9363L16 19.875L24.9388 10.935C25.2205 10.6532 25.6027 10.4949 26.0013 10.4949C26.3998 10.4949 26.782 10.6532 27.0638 10.935C27.3455 11.2168 27.5039 11.599 27.5039 11.9975C27.5039 12.396 27.3455 12.7782 27.0638 13.06L27.0613 13.0613Z" />
  ),
});
